import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { ValidityDateType } from 'app/back-office/shared/enum/season-reference.enum';
import { SeasonsReferenceService } from 'app/shared/services/seasons-reference.service';
import { log } from 'console';


@Component({
    selector: 'app-season-reference-filter',
    templateUrl: './season-reference-filter.component.html',
    styleUrls: ['./season-reference-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SeasonReferenceFilterComponent implements OnInit {

  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search season reference...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  constructor(
    private _seasonReference: SeasonsReferenceService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === ''){ 
      this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    }
    this.setDataToView(0);
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }
  
  setDataToView(skipCount: number) {
    (this.searchValue == undefined) ? this.searchValue = "" : null;
    this._seasonReference.getList(this.loaderId, skipCount, 20, this.searchValue, ValidityDateType.All,'id desc').subscribe(element => {
      this.dataToView = element.items.map(el => FilterMapper.SeasonReferenceFilter(el));
      this.totalCount = element.totalCount + 1;
      });
    }
}
